import { LandingPageCard } from "../LandingPageCards"
import CustomizedProfile from "../../assets/icons/customized_profile.svg"
import VideoPresentation from "../../assets/icons/video_presentation.svg"
import InteractivePresentation from "../../assets/icons/dynamic_presentation.svg"
import Button from "../Buttons"
import React from "react"

interface ProductFeatureProps {
  journeyHandler: () => void
}

const ProductFeature: React.FC<ProductFeatureProps> = ({
  journeyHandler
}) => {
  return (
    <section id="feature_product" className="bg-[#E0EDE5] text-center py-6 lg:py-20 layout-container lg:!px-40">
      <h2 className="lg:text-[45px] text-[28px] font-semibold text-[#232323]">
        Our product features
      </h2>
      <div className="bg-white flex-col lg:flex-row rounded-3xl mt-6 lg:my-[43px] gap-10 py-[35px] lg:px-[20px] lg:py-[40px] flex mx-auto">
        <LandingPageCard
          title="Customizable, White-labeled Digital Profiles"
          description="Replace outdated PDFs with interactive, white-labeled digital profiles for tech candidates. Showcase candidates with your own branding and enhance their presentation with engaging content."
          icon={CustomizedProfile}
          showBorder={true}
        />
        <LandingPageCard
          title="Video Presentations"
          description="Add up to three video introductions in candidate resumes, giving clients a better view of their skills and personality beyond just a resume."
          icon={VideoPresentation}
          showBorder={true}
        />
        <LandingPageCard
          title="Interactive, Dynamic Presentations"
          description="Transform standard resumes for tech roles into interactive, detailed profiles. Highlight key skills, achievements, and summaries, making the candidate evaluation process more efficient and engaging."
          icon={InteractivePresentation}
        />
      </div>
        <Button
          btn_label="Start your journey"
          on_click_handler={journeyHandler}
          other_classes="!bg-[#23FF9C] !text-[#232323] !text-[14px] px-5 lg:!w-44 mt-[15px] lg:mt-2 mx-auto mb-[15px]"
        />
    </section>
  )
}

export default ProductFeature;